import React from 'react'

import Navigation from '../components/Navigation/Navigation'
import ScrollPrototype from '../components/ScrollPrototype/ScrollPrototype'
import Image from '../components/Image/Image'
const Legacy = () => {
    return (
        <>
            <Navigation />
            <Image></Image>
            <ScrollPrototype></ScrollPrototype>
            <Image></Image>
        </>
    )
}

export default Legacy